import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import Slider from 'react-slick';
import { useUnit } from 'effector-react';
import { useProductParams } from '../../hooks/useProductParams';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { EProducts } from '../../model/enums';
import { $cartState } from '../../store/models/cart';

import styles from './styles.module.scss';

const CustomPaging = () => {
  const { selectedProductSize } = useUnit($cartState);
  let { productType, productSize } = useProductParams();

  const size = selectedProductSize || productSize;

  let images: Array<string> = [];

  switch (productType) {
    case EProducts.acs:
      images = [
        `/assets/images/products/accessories/plastic-tray-${size}-base.jpg`,
        `/assets/images/products/accessories/plastic-tray-${size}-2.jpg`,
        `/assets/images/products/accessories/plastic-tray-${size}-3.jpg`,
        `/assets/images/products/accessories/plastic-tray-${size}-4.jpg`,
        // `/assets/images/products/accessories/plastic-tray-${size}-5.jpg`,
      ];
      break;
    case EProducts.grs:
      images = [
        `/assets/images/products/grass/freshGrass_${size}_close_side.png`,
        `/assets/images/products/grass/freshGrass_${size}_close_straight.png`,
        `/assets/images/products/grass/freshGrass_${size}_open_side.png`,
        `/assets/images/products/grass/freshGrass_${size}_open_straight.png`,
        `/assets/images/sizes/${size}/size.avif`,
      ];
      break;
    case EProducts.ctn:
      images = [
        `/assets/images/products/catnips/catnip-${size}-base.jpg`,
        `/assets/images/products/catnips/ad.jpg`,
        `/assets/images/products/catnips/scan-me.jpg`,
      ];
      break;
    case EProducts.sds:
      images = [
        '/assets/images/products/catgrassSeeds/1.jpg',
        '/assets/images/products/catgrassSeeds/3.jpg',
        '/assets/images/products/catgrassSeeds/4.jpg',
        '/assets/images/products/catgrassSeeds/5.jpg',
        '/assets/images/products/catgrassSeeds/6.jpg',
        '/assets/images/products/catgrassSeeds/7.jpg',
      ];
      break;

    default:
      break;
  }

  const settings = {
    customPaging: (i: number) => (
      <img
        src={images[i]}
        className={styles.sliderDotImg}
        alt={`thumbnail-${i + 1}`}
      />
    ),
    dots: true,
    dotsClass: 'slick-dots slick-thumb',
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: '#006633', fontSize: '28px' }}
        />
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: 'block' }}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={faChevronLeft}
          style={{ color: '#006633', fontSize: '28px' }}
        />
      </div>
    );
  }

  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className={styles.sliderItem}>
            <img src={image} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CustomPaging;
